import { discountBadgeGradient } from '../utils/formatters'

/**
 * Absolute-positioned percentage-off badge for a deal card.
 * @param {{ percent: number }} props
 */
const DiscountBadge = ({ percent }) => (
  <div
    className={`
      absolute top-3 left-3 z-10
      bg-gradient-to-r ${discountBadgeGradient(percent)}
      text-white text-xs font-black
      px-2.5 py-1 rounded-lg shadow-lg
      tracking-wide
    `}
    aria-label={`${percent}% off`}
  >
    -{percent}%
  </div>
)

export default DiscountBadge
